export const caScheduleTypes = {
  S19Schedule: "S19Schedule",
  S19ASchedule: "S19ASchedule",
  S19BSchedule: "S19BSchedule",
  S19DSchedule: "S19DSchedule",
  S16Schedule: "S16Schedule",
};

export const caScheduleDetails = {
  S19Schedule: { name: "S19 Capital Allowance Schedule" },
  S19ASchedule: { name: "S19A Capital Allowance Schedule" },
  S19BSchedule: { name: "S19B Capital Allowance Schedule" },
  S19DSchedule: { name: "S19D Capital Allowance Schedule" },
  S16Schedule: { name: "S16 Capital Allowance Schedule" },
};

export const CA_ADDITION_SOURCE_KEYS = {
  manual: "manual",
  plSchedules: "pl_schedules",
  faRegister: "fa_register",
};

export const CA_ADDITION_SOURCE_LABELS = {
  [CA_ADDITION_SOURCE_KEYS.manual]: "Manual",
  [CA_ADDITION_SOURCE_KEYS.plSchedules]: "P&L Schedules",
  [CA_ADDITION_SOURCE_KEYS.faRegister]: "FA Register",
};

export const FA_REGISTER_PRIOR_YEAR_SOURCE = "fa_register_previous_year";
export const FA_REGISTER_CURRENT_YEAR_SOURCE = "fa_register_current_year";
